import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from './config.service';
import { AuthService } from './auth.service';
import { GetMessagesRequest, GetMessagesResponse, GetUnreadMessageCountsRequest, GetUnreadMessageCountsResponse, PostMessageAnswerRequest, PostMessageAnswerResponse } from '../models/messages.models';

@Injectable({
  providedIn: 'root'
})
export class MessagesService {
  private apiUrl: string;

  constructor(private http: HttpClient, private configService: ConfigService, private authService: AuthService) {
    this.apiUrl = this.configService.getConfig().apiBaseUrl;
  }

  private getHeaders(): HttpHeaders {
    const token = this.authService.getToken();
    let headers = new HttpHeaders();
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  }

  private getQueryParams(params: any): HttpParams {
    let httpParams = new HttpParams();
    Object.keys(params).forEach(key => {
      httpParams = httpParams.append(key, params[key]);
    });
    return httpParams;
  }

  getMessagesList(request: GetMessagesRequest): Observable<GetMessagesResponse> {
    return this.http.get<GetMessagesResponse>(`${this.apiUrl}/messages/get-messages`, { 
      headers: this.getHeaders(), 
      params: this.getQueryParams(request) 
    });
  }

  getUnreadMessagesCount(request: GetUnreadMessageCountsRequest): Observable<GetUnreadMessageCountsResponse> {
    return this.http.get<GetUnreadMessageCountsResponse>(`${this.apiUrl}/messages/get-unread-messages-count`, { 
      headers: this.getHeaders(), 
      params: this.getQueryParams(request) 
    });
  }

  postMessageAnswer(request: PostMessageAnswerRequest): Observable<PostMessageAnswerResponse> {
    return this.http.post<PostMessageAnswerResponse>(`${this.apiUrl}/messages/post-message-answer`, request, { 
      headers: this.getHeaders() 
    });
  }
}